import { TransactionsQuery, TransactionsQueryVariables } from "@ctypes";
import { TRANSACTIONS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const DEFAULT_SIZE = 10;

export const useTransactions = (variables?: TransactionsQueryVariables) => {
  const {
    data: queryData,
    loading,
    fetchMore: fetchMoreDefault,
    ...rest
  } = useQuery<TransactionsQuery, TransactionsQueryVariables>(TRANSACTIONS, {
    variables: {
      size: DEFAULT_SIZE,
      ...variables,
    },
  });

  const nextCursor = queryData?.transactions?.nextCursor;

  const fetchMore = () => {
    if (nextCursor === null || loading) return;

    return fetchMoreDefault({
      variables: {
        size: DEFAULT_SIZE,
        cursor: nextCursor,
      },
    });
  };

  const data = queryData?.transactions?.elements ?? [];

  return { data, loading, fetchMore, ...rest };
};
